import { useEffect, useState } from "react";
import {
    CircularProgressbar,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

export default function AirForceLunc() {

    const fullscreenHandler = async () => await document.getElementsByTagName("iframe")[0].requestFullscreen()

    return (
        <>
            <div className="w-full h-full absolute z-10 overflow-x-clip">
                <div className="rounded-full absolute top-0 left-0 bg-blue blur-xl animate-blob" style={{ opacity: .5, width: "40rem", height: "40rem" }}></div>
                <div className="rounded-full absolute top-[60%] right-0 bg-green blur-xl animate-blob" style={{ opacity: .5, animationDelay: "1s", width: "40rem", height: "40rem" }}></div>
            </div>
            <main className="relative py-24 px-8 lg:px-12 z-10 flex flex-col justify-center">
                <h2 className="py-12 ranking-title font-display text-4xl font-medium text-jacarta-700 dark:text-white">
                    Air Force Lunc
                </h2>
                <div className="h-screen w-full rounded-lg bg-black flex flex-col justify-center items-center" id="main-game">
                    <GradientSVG />
                    {/* <p className="text-xl lg:text-2xl ranking-title capitalize font-bold">GhostHawk Tournament On February 5, 2024 at 1 PM UTC</p> */}
                    {/* <CountdownComponent /> */}
                    <iframe src="https://html-classic.itch.zone/html/12541161/index.html" width="100%" height="100%" allowFullScreen={true} allow="autoplay; fullscreen; monetization; xr-spatial-tracking; gamepad; gyroscope; accelerometer; xr; cross-origin-isolated" className="rounded-2xl border-none focus-visible:outline-none"></iframe>
                </div>
                <button
                    type="button"
                    className="bg-black/70 p-4 rounded-lg w-full lg:w-1/5 mt-4"
                    onClick={fullscreenHandler}
                >
                    Play in fullscreen
                </button>
                <div className="mt-10 text-white pl-4 pt-4 pb-4 pr-6 lg:pr-42 flex flex-col gap-8 bg-black/30 backdrop-blur-xl rounded-xl">
                    <p className="lg:text-lg"><span className="font-bold font-display">Introducing <span className="ranking-title">Air Force Lunc -
                        The Alliance</span>,</span> the 1st air combat fighter game on Luna Classic Blockchain where you can
                        <span className="font-bold">play to earn</span> while building your own squadron in the realm of Lunc Planet
                    </p>
                    <div>
                        <p className="lg:text-lg font-bold mb-1">Controls</p>
                        <ul className="pl-4">
                            <li>WASD or arrow keys = plane control</li>
                            <li>Mouse</li>
                        </ul>
                    </div>
                    <div>
                        <p className="lg:text-lg font-bold mb-1">Platform</p>
                        <ul className="pl-4">
                            <li>Web browser</li>
                            <li>Android</li>
                        </ul>
                    </div>
                    <div>
                        <p className="lg:text-lg font-bold mb-1">Release Date</p>
                        <ul className="pl-4">
                            <li>November 2023 (WebGL)</li>
                        </ul>
                    </div>
                    <div>
                        <ul className="game-detail">
                            <li className="text-jacarta-300">Developer:</li>
                            <li className="font-bold ranking-title">Garuda Games</li>
                            <li className="text-jacarta-300">Released:</li>
                            <li className="font-semibold">November 2023</li>
                            <li className="text-jacarta-300">Technology:</li>
                            <li className="font-semibold">HTML5 (Unity WebGL)</li>
                            <li className="text-jacarta-300">Platforms:</li>
                            <li className="font-semibold">Browser (desktop, mobile, tablet) Android</li>
                        </ul>
                    </div>
                    <div>
                        <div className="inline-flex space-x-4">
                            <a href="https://drive.google.com/file/d/1lyys-GPVwwCvzviipOCOndtU7ec_uZDt/view?usp=drivesdk"
                                className="w-36 rounded-full bg-accent py-3 px-8 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark">
                                Desktop
                            </a>
                            <a href="https://drive.google.com/file/d/1lzruCmTmun9kCe2HALAsmWluI4hYb7lM/view?usp=drivesdk"
                                className="w-36 rounded-full bg-white py-3 px-8 text-center font-semibold text-accent shadow-white-volume transition-all hover:bg-accent-dark hover:text-white hover:shadow-accent-volume">
                                Android
                            </a>
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}

function GradientSVG() {
    const idCSS = "custom-gradient";
    const gradientTransform = `rotate(180)`;
    return (
        <svg style={{ height: 0 }}>
            <defs>
                <linearGradient id={idCSS}>
                    <stop offset="10%" stopColor="#06E7AF" />
                    <stop offset="40%" stopColor="#0A85ED" />
                </linearGradient>
            </defs>
        </svg>
    );
}

type CountdownProps = {
    days: number,
    hours: number,
    minutes: number,
    seconds: number,
}

function CountdownComponent() {

    const [countdown, setCountdown] = useState<CountdownProps>({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    })

    useEffect(() => {
        const endsDate = new Date("2024-01-08T22:00:00+07:00")

        const time = setInterval(() => {
            let timeDifference = endsDate.valueOf() - new Date().valueOf();

            let days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            let hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

            setCountdown({
                days: days,
                hours: hours,
                minutes: minutes,
                seconds: seconds
            })
        }, 1000)

        return () => clearInterval(time)
    }, [])

    return (
        <div className="flex flex-row gap-7 flex-wrap justify-around lg:justify-center">
            {
                countdown.days === 0 && countdown.hours === 0 && countdown.minutes === 0 && countdown.seconds === 0
                    ? <p className="text-lg lg:text-xl"></p>
                    : Object.keys(countdown).map((key, index) =>
                    (
                        <div className="w-24 h-24 mt-4" key={index}>
                            <p className="capitalize text-center mb-2">{key}</p>
                            <CircularProgressbar
                                value={countdown[key as ('days' | 'minutes' | 'seconds' | 'hours')]}
                                maxValue={
                                    key === "seconds" || key === "minutes"
                                        ? 60
                                        : key === "days"
                                            ? 30
                                            : 24
                                }
                                text={`${countdown[key as ('days' | 'minutes' | 'seconds' | 'hours')]}`}
                                strokeWidth={5}
                                styles={{
                                    trail: {
                                        stroke: "#121212"
                                    },
                                    path: {
                                        stroke: "url(#custom-gradient)",
                                        height: "100%"
                                    }
                                }}
                            />
                        </div>
                    )
                    )
            }
        </div>
    )
}